/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TokenAmount
 */
export interface TokenAmount {
  /**
   *
   * @type {string}
   * @memberof TokenAmount
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof TokenAmount
   */
  address?: string
  /**
   *
   * @type {number}
   * @memberof TokenAmount
   */
  amount?: number
}

export function TokenAmountFromJSON(json: any): TokenAmount {
  return TokenAmountFromJSONTyped(json, false)
}

export function TokenAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenAmount {
  if (json === undefined || json === null) {
    return json
  }
  return {
    code: !exists(json, 'code') ? undefined : json['code'],
    address: !exists(json, 'address') ? undefined : json['address'],
    amount: !exists(json, 'amount') ? undefined : json['amount'],
  }
}

export function TokenAmountToJSON(value?: TokenAmount | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    code: value.code,
    address: value.address,
    amount: value.amount,
  }
}
